const backtrackingProblems = [
  {
      title: "Subsets",
      url: "https://leetcode.com/problems/subsets/"
    },
    {
      title: "Subsets II",
      url: "https://leetcode.com/problems/subsets-ii/"
    },
    {
      title: "Permutations",
      url: "https://leetcode.com/problems/permutations/"
    },
    {
      title: "Combination Sum",
      url: "https://leetcode.com/problems/combination-sum/"
    },
    {
      title: "Letter Combinations of Phone Number",
      url: "https://leetcode.com/problems/letter-combinations-of-a-phone-number/"
    }
];
export default backtrackingProblems;